import { useBrowserEventListener } from '@sg/garnish';

import { type UseResetOnWindowBlurParams } from './useResetOnWindowBlur.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useResetOnWindowBlur = (params: UseResetOnWindowBlurParams) => {
  const { onReset, skip } = params;

  useBrowserEventListener(DOCUMENT_ELEMENT, 'mouseleave', onReset, undefined, skip);
  useBrowserEventListener(WINDOW, 'blur', onReset, undefined, skip);
};

// ─── Constants ──────────────────────────────────────────────────────────────

const DOCUMENT_ELEMENT = typeof document === 'undefined' ? null : document.documentElement;
const WINDOW = typeof window === 'undefined' ? null : window;
